import React, { Component } from "react";
import { Modal, toast, Tooltip } from "materialize-css";
import MetaDecorator from "../../services/MetaDecorator";
import contact from "../../../media/images/contact.jpg";
import contactMobile from "../../../media/images/contactMobile.jpg";
import ReCAPTCHA from "react-google-recaptcha";

class Contact extends Component {
  constructor(props) {
    super(props);
    this.modalRef = React.createRef();
    this.tooltipRef = React.createRef();
    this.state = {
      consultationFor: "",
      reason: "",
      scope: "",
      branch: "",
      contactMessage: "",
      firstAndLastName: "",
      telephone: "",
      email: "",
      isOk: false,
      isCollaboration: null,
      isVerified: false,
      recaptchaToken: "",
      loading: false,
      width: window.innerWidth,
    };
  }

  componentDidMount = () => {
    const wrappers = document.getElementsByClassName("nav-wrapper");
    if (wrappers && wrappers[1]) {
      const links = wrappers[1].querySelectorAll("ul")[0].querySelectorAll("a");
      for (let i = 0; i < links.length; i++) {
        links[i].removeAttribute("class");
        if (links[i].id === "contact") {
          links[i].setAttribute("class", "orange-text text-darken-4");
        }
      }
    }

    const sidenav = document.getElementsByClassName("sidenav")[0];
    if (sidenav) {
      const mobileTabs = sidenav.querySelectorAll("a");
      for (let i = 0; i < mobileTabs.length; i++) {
        if (mobileTabs[i].id === "contactMobile") {
          mobileTabs[i].removeAttribute("class");
          mobileTabs[i].setAttribute(
            "class",
            "orange-text text-darken-4 grey darken-3",
          );
        }
      }
    }

    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.isCollaboration === false &&
      prevState.isCollaboration !== this.state.isCollaboration
    ) {
      const elems = this.tooltipRef.current
        ? this.tooltipRef.current.querySelectorAll(".tooltipped")
        : [];
      Tooltip.init(elems);
    }
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  handleChange = (e) => {
    const { id, value, checked } = e.target;
    if (id === "hasAcceptedUsingConds") {
      this.setState({ hasAcceptedUsingConds: checked });
    } else if (id === "telephone") {
      if (/^\+?\d{0,15}$/.test(value) || value === "") {
        this.setState({ telephone: value });
      }
    } else if (id === "companyName") {
      this.setState({ consultationFor: value });
    } else if (id === "collaboration") {
      this.setState({
        scope: "Digitale Zusammenarbeit",
        isCollaboration: true,
      });
    } else if (id === "website") {
      this.setState({ scope: "Webseite", isCollaboration: false });
    } else if (id === "planning") {
      this.setState({ reason: "Vorbereitung und Planung" });
    } else if (id === "design") {
      this.setState({ reason: "Konzeption und Design" });
    } else if (id === "development") {
      this.setState({ reason: "Websiteentwicklung" });
    } else if (id === "modernising") {
      this.setState({ reason: "Modernisierung" });
    } else if (id === "sharepoint") {
      this.setState({ reason: "Microsoft SharePoint Online" });
    } else if (id === "powerplatform") {
      this.setState({ reason: "Microsoft Power Platform" });
    } else if (id === "teams") {
      this.setState({ reason: "Microsoft Teams" });
    } else if (id === "azure") {
      this.setState({ reason: "Microsoft Azure" });
    } else if (id === "webSitesOther") {
      this.setState({ reason: "Webseiten, Sonstiges" });
    } else if (id === "other") {
      this.setState({ reason: "Sonstiges" });
    } else {
      this.setState({ [id]: value });
    }
  };

  verifyHuman = (token) => {
    this.setState({ isVerified: !!token, recaptchaToken: token || "" });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const {
      consultationFor,
      reason,
      branch,
      contactMessage,
      firstAndLastName,
      telephone,
      email,
      isVerified,
      recaptchaToken,
    } = this.state;

    if (!isVerified || !recaptchaToken) {
      return toast({
        html: "Bitte stellen Sie sicher, dass Sie kein Roboter sind.",
      });
    }

    const payload = {
      consultationFor,
      reason,
      branch,
      contactMessage,
      firstAndLastName,
      telephone,
      email,
      recaptchaToken,
    };

    const FUNCTION_URL =
      "https://jetminds-contact-fqajcycvgrbjhecg.francecentral-01.azurewebsites.net/api/contact?code=y_wyaB3T_bG6Ic_3_f62kMxKeL9qj3p5xpP8axhKeaZ6AzFuKgb-Rg==";

    const correlationId =
      window && window.crypto && typeof window.crypto.randomUUID === "function"
        ? window.crypto.randomUUID()
        : String(Date.now());

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Correlation-Id": correlationId,
      },
      body: JSON.stringify(payload),
    };

    try {
      this.setState({ loading: true });
      const response = await fetch(FUNCTION_URL, options);

      const isJson = (response.headers.get("content-type") || "").includes(
        "application/json",
      );
      const body = isJson
        ? await response.json().catch(() => null)
        : await response.text();

      if (!response.ok) {
        const msg =
          (body && body.error) ||
          body ||
          `Request failed with ${response.status}`;
        throw new Error(msg);
      }

      if (body && (body.ok === true || body.status === "ok")) {
        const instance = Modal.init(this.modalRef.current, {
          dismissible: false,
        });
        instance.open();

        if (window.grecaptcha) window.grecaptcha.reset();
        this.setState({
          consultationFor: "",
          reason: "",
          scope: "",
          branch: "",
          contactMessage: "",
          firstAndLastName: "",
          telephone: "",
          email: "",
          isOk: false,
          isCollaboration: null,
          isVerified: false,
          recaptchaToken: "",
          loading: false,
        });
      } else {
        this.setState({ loading: false });
        toast({ html: "Unerwartete Antwort vom Server." });
      }
    } catch (err) {
      this.setState({ loading: false });
      console.error("Network/server error:", err);
      toast({
        html: err.message || "Netzwerkfehler – bitte später erneut versuchen.",
      });
    }
  };

  renderNeed = () => {
    const { isCollaboration, reason } = this.state;
    if (isCollaboration) {
      return (
        <div className="col s12 m12">
          <label>Bitte auswählen *</label>
          <p className="light">
            <label>
              <input
                id="sharepoint"
                className="validate"
                name="group3"
                type="radio"
                required
                onChange={this.handleChange}
                checked={reason === "Microsoft SharePoint Online"}
              />
              <span className="black-text">Microsoft SharePoint Online</span>
            </label>
          </p>
          <p className="light">
            <label>
              <input
                id="powerplatform"
                className="validate"
                name="group3"
                type="radio"
                required
                onChange={this.handleChange}
                checked={reason === "Microsoft Power Platform"}
              />
              <span className="black-text">Microsoft Power Platform</span>
            </label>
          </p>
          <p className="light">
            <label>
              <input
                id="teams"
                className="validate"
                name="group3"
                type="radio"
                required
                onChange={this.handleChange}
                checked={reason === "Microsoft Teams"}
              />
              <span className="black-text">Microsoft Teams</span>
            </label>
          </p>
          <p className="light">
            <label>
              <input
                id="azure"
                className="validate"
                name="group3"
                type="radio"
                required
                onChange={this.handleChange}
                checked={reason === "Microsoft Azure"}
              />
              <span className="black-text">Microsoft Azure</span>
            </label>
          </p>
          <p className="light">
            <label>
              <input
                id="other"
                className="validate"
                name="group3"
                type="radio"
                required
                onChange={this.handleChange}
                checked={reason === "Sonstiges"}
              />
              <span className="black-text">Sonstiges</span>
            </label>
          </p>
        </div>
      );
    } else if (isCollaboration === false) {
      return (
        <div className="col s12 m12" ref={this.tooltipRef}>
          <label>Bitte auswählen *</label>
          <p className="light">
            <label>
              <input
                id="planning"
                className="validate"
                name="group4"
                type="radio"
                required
                onChange={this.handleChange}
                checked={reason === "Vorbereitung und Planung"}
              />
              <span className="black-text">Vorbereitung und Planung</span>
              <i
                className="material-icons right tooltipped"
                data-position="left"
                data-tooltip="Vorbereitung und Planung, denn ich stehe noch am Anfang."
                style={{ fontSize: "18px" }}
              >
                info_outline
              </i>
            </label>
          </p>
          <p className="light">
            <label>
              <input
                id="design"
                className="validate"
                name="group4"
                type="radio"
                required
                onChange={this.handleChange}
                checked={reason === "Konzeption und Design"}
              />
              <span className="black-text">Konzeption und Design</span>
              <i
                className="tooltipped material-icons right"
                data-position="left"
                data-tooltip="Konzeption und Design, weil ich bereits vorbereitet bin und einen konkreten Plan habe."
                style={{ fontSize: "18px" }}
              >
                info_outline
              </i>
            </label>
          </p>
          <p className="light">
            <label>
              <input
                id="development"
                className="validate"
                name="group4"
                type="radio"
                required
                onChange={this.handleChange}
                checked={reason === "Websiteentwicklung"}
              />
              <span className="black-text">Websiteentwicklung</span>
              <i
                className="tooltipped material-icons right"
                data-position="left"
                data-tooltip="Websiteentwicklung, da ich bereits vorbereitet bin und ein konkretes Konzept und Design habe."
                style={{ fontSize: "18px" }}
              >
                info_outline
              </i>
            </label>
          </p>
          <p className="light">
            <label>
              <input
                id="modernising"
                className="validate"
                name="group4"
                type="radio"
                required
                onChange={this.handleChange}
                checked={reason === "Modernisierung"}
              />
              <span className="black-text">Modernisierung</span>
              <i
                className="tooltipped material-icons right"
                data-position="left"
                data-tooltip="Modernisierung, ich haben eine bestehende Website und möchte diese auf den neuesten Stand bringen."
                style={{ fontSize: "18px" }}
              >
                info_outline
              </i>
            </label>
          </p>
          <p className="light">
            <label>
              <input
                id="webSitesOther"
                className="validate"
                name="group4"
                type="radio"
                required
                onChange={this.handleChange}
                checked={reason === "Webseiten, Sonstiges"}
              />
              <span className="black-text">Sonstiges</span>
            </label>
          </p>
        </div>
      );
    }
    return null;
  };

  render() {
    const { width, loading } = this.state;
    const isMobile = width <= 600;
    const isTablet = width <= 992 && width > 600;

    return (
      <React.Fragment>
        <MetaDecorator
          title="JetMinds | Kontakt, wir stehen Ihnen zur Seite"
          descrption="Kontaktieren Sie uns. Wir stehen Ihnen mit fundierter technischer & funktioneller Beratung rund um das Thema moderne Informationstechnologien und digitale Transformation zur Seite"
          url="https://www.jetminds.de/kontakt/"
        />
        <div className="pageImageTitle">
          {isMobile ? (
            <img
              className="responsive-img"
              style={{ width: "100%" }}
              src={contactMobile}
              alt="JetMinds Kontakt"
              loading="lazy"
            />
          ) : (
            <img
              className="responsive-img"
              style={{ width: "100%" }}
              src={contact}
              alt="JetMinds Kontakt"
              loading="lazy"
            />
          )}
          {isMobile || isTablet ? (
            <div className="imgTxtMobile">
              <h1
                className={`white-text ${isTablet ? "isTablet" : "isMobile"}`}
              >
                Kontakt
              </h1>
            </div>
          ) : (
            <div className="imgTxt">
              <h1 className="white-text">Kontakt</h1>
            </div>
          )}
        </div>

        <div className="container">
          <div className="section">
            <div className="row">
              <div className="col s12 m12">
                <h1 className={`${isMobile ? "pageTitleM" : "pageTitle"}`}>
                  Sie erreichen uns per{" "}
                  <span className="orange-text text-darken-4">E-Mail</span>,
                  telefonisch oder durch die{" "}
                  <span className="orange-text text-darken-4">
                    Kontaktanfrage
                  </span>
                </h1>
              </div>
            </div>
            <div className="row">
              <blockquote className="light">
                Wir sind Ihr Impulsgeber rund um das Thema moderne
                Informationstechnologien und digitale Transformation. Für eine
                unverbindliche Erstanfrage, benutzen Sie die Kontaktanfrage oder
                schreiben Sie uns eine E-Mail an{" "}
                <a
                  className="orange-text text-darken-4"
                  href="mailto:info@jetminds.de"
                >
                  info@jetminds.de
                </a>
                . Bitte beachten Sie, dass nur die für die Bearbeitung
                erforderlichen personenbezogenen Informationen angegeben werden.
                Detailierte Informationen über die Verarbeitung Ihrer
                personenbezogenen Daten und Ihre Rechte als Betroffener können
                Sie in unserer{" "}
                <a
                  className="privacyPolicy orange-text text-darken-4"
                  href="/datenschutzerklaerung"
                  target="_blank"
                  rel="noreferrer"
                >
                  Datenschutzerklärung
                </a>{" "}
                nachlesen.
              </blockquote>
            </div>
          </div>

          <div className="section">
            <div className="row">
              <form onSubmit={this.handleSubmit}>
                <div className="input-field col s12 m6">
                  <input
                    className="validate"
                    required
                    id="firstAndLastName"
                    type="text"
                    value={this.state.firstAndLastName}
                    onChange={this.handleChange}
                  />
                  <label
                    htmlFor="firstAndLastName"
                    className={this.state.firstAndLastName ? "active" : ""}
                  >
                    Name *
                  </label>
                </div>

                <div className="input-field col s12 m6">
                  <input
                    className="validate"
                    required
                    id="email"
                    type="email"
                    value={this.state.email}
                    onChange={this.handleChange}
                  />
                  <label
                    htmlFor="email"
                    className={this.state.email ? "active" : ""}
                  >
                    Email *
                  </label>
                </div>

                <div className="input-field col s12 m6">
                  <input
                    className="validate"
                    required
                    id="companyName"
                    type="text"
                    value={this.state.consultationFor}
                    onChange={this.handleChange}
                  />
                  <label
                    htmlFor="companyName"
                    className={this.state.consultationFor ? "active" : ""}
                  >
                    Firma *
                  </label>
                </div>

                <div className="input-field col s12 m6">
                  <input
                    className="validate"
                    required
                    id="telephone"
                    value={this.state.telephone}
                    type="tel"
                    onChange={this.handleChange}
                  />
                  <label
                    htmlFor="telephone"
                    className={this.state.telephone ? "active" : ""}
                  >
                    Telefon *
                  </label>
                </div>

                <div className="input-field col s12 m12">
                  <input
                    type="text"
                    id="branch"
                    value={this.state.branch}
                    onChange={this.handleChange}
                  />
                  <label
                    htmlFor="branch"
                    className={this.state.branch ? "active" : ""}
                  >
                    Branche
                  </label>
                </div>

                <div className="col s12 m6">
                  <label>Es geht um *</label>
                  <p className="light">
                    <label>
                      <input
                        id="collaboration"
                        className="validate"
                        name="group2"
                        type="radio"
                        required
                        onChange={this.handleChange}
                        checked={this.state.isCollaboration === true}
                      />
                      <span className="black-text">
                        Digitale Zusammenarbeit
                      </span>
                    </label>
                  </p>
                  <p className="light">
                    <label>
                      <input
                        id="website"
                        className="validate"
                        name="group2"
                        type="radio"
                        required
                        onChange={this.handleChange}
                        checked={this.state.isCollaboration === false}
                      />
                      <span className="black-text">Webseiten</span>
                    </label>
                  </p>
                </div>

                {this.renderNeed()}

                <div className="input-field col s12 m12">
                  <textarea
                    required
                    id="contactMessage"
                    className="materialize-textarea validate"
                    value={this.state.contactMessage}
                    onChange={this.handleChange}
                  />
                  <label
                    htmlFor="contactMessage"
                    className={this.state.contactMessage ? "active" : ""}
                  >
                    Nachricht *
                  </label>
                </div>

                <label className="input-field col s12 m12">
                  <input type="checkbox" className="validate" required />
                  <span>
                    Ich bin mit der Speicherung meiner Daten zur elektronischen
                    Verarbeitung meiner Anfrage einverstanden und akzeptiere die{" "}
                    <a
                      className="privacyPolicy grey-text text-lighten"
                      href="/datenschutzerklaerung"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Bestimmungen zum Datenschutz
                    </a>
                    . Mein Einverständnis kann ich jederzeit widerrufen.
                  </span>
                </label>

                <div className="input-field col s12 m12">
                  <ReCAPTCHA
                    sitekey="6LemgK0ZAAAAAN7uy7eRGFe2pgG7TZSWqfC3jEWR"
                    onChange={this.verifyHuman}
                    theme="Dark"
                    lang="de-DE"
                  />
                </div>

                <div className="input-field col s12">
                  <button
                    className="btn orange darken-4"
                    style={{ width: "302px" }}
                    disabled={loading}
                  >
                    {loading ? "Sende..." : "Absenden"}
                  </button>
                </div>
              </form>

              <div id="modal1" className="modal" ref={this.modalRef}>
                <div className="modal-content">
                  <h5>
                    Vielen Dank für Ihre Kontaktanfrage und Ihr Interesse!
                  </h5>
                  <p className="light">
                    Wir haben Ihre Nachricht erhalten und werden uns zu Ihrem
                    Anliegen zeitnah bei Ihnen melden. Wir freuen uns auf Sie!
                  </p>
                  <p className="light">Freundliche Grüße</p>
                  <div className="modal-footer">
                    <a
                      href="/kontakt"
                      className="modal-close btn-flat waves-effect waves-green btn-flat green white-text right"
                    >
                      Ok
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/layout/pages/Contact.js